import AppDispatcher from '../dispatcher/AppDispatcher';
import ProjectionConstants from '../constants/ProjectionConstants';
import ProjectionSettingsParser from '../parsers/projections/ProjectionSettingsParser';

const ProjectionActionCreator = {
  /**
   * Action to get all accounts from API
   */
  // projections page ends
  getEarningsAndCommitment() {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.REQUEST_EARNINGS_COMMITMENTS,
    });
  },
  projectionCrunchBackClicked() {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.PROJECTION_CRUNCH_BACK_CLICKED,
    });
  },
  handleEarningsCommitmentSuccess(response) {
    const projectionParser = new ProjectionSettingsParser();
    const parsedData = projectionParser.parseProjectionSettings(response);
    AppDispatcher.handleServerAction({
      actionType: ProjectionConstants.REQUEST_EARNINGS_COMMITMENTS_SUCCESS,
      data: parsedData,
    });
  },
  handleEarningsCommitmentError(error) {
    AppDispatcher.handleServerAction({
      actionType: ProjectionConstants.GET_PROJECTION_PREFERENCE_ERROR,
      data: error,
    });
  },
  handleProjectionDoneSuccess(response, status, accountId) {
    AppDispatcher.handleServerAction({
      actionType: ProjectionConstants.DONE_PROJECTIONS_SUCCESS,
      data: response,
      status,
      accountId,
    });
  },
  handleProjectionDoneError(error) {
    AppDispatcher.handleServerAction({
      actionType: ProjectionConstants.PUT_PROJECTION_PREFERENCE_ERROR,
      data: error,
    });
  },
  // to clear flag when modal gets closed
  clearModalFlag(flag) {
    AppDispatcher.handleServerAction({
      actionType: ProjectionConstants.SET_MODAL_FLAG,
      data: flag,
    });
  },
  // projections and settings starts
  /**
   * Action to get all accounts from API
   */
  // TO HANDLE SERVER ACTIONS
  /**
   * Action to handle an API call success
   * @param  {object} response getCases api response
   */
  // projections and settings ends
  getProjectionAlerts() {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.GET_PROJECTION_ALERTS,
    });
  },
  // TO HANDLE SERVER ACTIONS
  /**
   * Action to handle an API call success
   * @param  {object} response getCases api response
   */
  doneProjections(projectionObject, id) {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.DONE_PROJECTIONS,
      data: projectionObject,
      accountId: id,
    });
  },
  getCategoryTagsForTab(categoryTagArray) {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.CATEGORY_TAGS_FOR_PROJECTION_TAB,
      data: categoryTagArray,
    });
  },
  getUserTagsForTab(userTagArray) {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.USER_TAGS_FOR_PROJECTION_TAB,
      data: userTagArray,
    });
  },
  setAlertNotificationAmount(alertsAmountValue) {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.SET_AMOUNT_FOR_NOTIFICATION_ALERT,
      data: alertsAmountValue,
    });
  },
  setAlertsNotificationFlag(notificationFlag) {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.SET_NOTIFICATION_FLAG,
      data: notificationFlag,
    });
  },
  setEarningsId(value) {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.GET_EARNINGS_ID,
      data: value,
    });
  },

  handleFSProjectionTourDone() {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.PROJECTION_TOUR_DONE_CLICKED,
    });
  },
  handleProjectionSettingLeaveSetup() {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.PROJECTION_LEAVE_SETUP,
    });
  },
  // new ui methods ...............
  getAccountId(accountId) {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.GET_ACCOUNT_ID,
      data: accountId,
    });
  },
  requestProjectionSummary(accountId) {
    AppDispatcher.handleServerAction({
      actionType: ProjectionConstants.GET_PROJECTION_SUMMARY,
      data: accountId,
    });
  },
  handleProjectionSummarySuccess(response, status, accountId) {
    // const projSummParser = new ProjectionSettingsParser();
    // const obj = projSummParser.parseProjectionSummary(response, status, accountId);
    AppDispatcher.handleServerAction({
      actionType: ProjectionConstants.GET_PROJECTION_SUMMARY_SUCCESS,
      data: response,
      status,
      accountId,
    });
  },
  handleProjectionSummaryFailure(response, status, accountId) {
    AppDispatcher.handleServerAction({
      actionType: ProjectionConstants.GET_PROJECTION_SUMMARY_FAILURE,
      data: response,
      status,
      accountId,
    });
  },
  // methods handling from AccountDetailComponent
  pageMode(mode) {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.PAGE_MODE,
      data: mode,
    });
  },
  pageData(pageData) {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.PAGE_DATA,
      data: pageData,
    });
  },
  setAccountId(accountId) {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.ACCOUNT_ID,
      data: accountId,
    });
  },
  resetSettings() {
    AppDispatcher.handleViewAction({
      actionType: ProjectionConstants.RESET_SETTINGS,
    });
  },
};

export default ProjectionActionCreator;
